import { SET_RESERVE_LIST_ID, SetReserveListId } from './types';
import RoutingUtils from '../../shared/utils/utils-routing';
import { RESERVE_ACCEPT_ACTION_VALUE, RESERVE_REJECT_ACTION_VALUE } from '../../shop/reserve/constants';
import * as consts from '../constants';

export type ReserveActionValue = typeof RESERVE_ACCEPT_ACTION_VALUE | typeof RESERVE_REJECT_ACTION_VALUE;

export function openReserveListId(listId: string, isCollectionNavigationV2Enabled: boolean) {
    RoutingUtils.pushUrl(
        `${isCollectionNavigationV2Enabled ? '/collectionmgmt/reserves' : consts.PATH_RESERVE}/${listId}`
    );
}

/* GENERATE */

export const setActiveReserveListId = (listId: string): SetReserveListId => {
    return { type: SET_RESERVE_LIST_ID, payload: listId };
};
